module.exports = __webpack_public_path__ + "static/media/accordion.8cd74669.png";